
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veteran-services",
      function () {
        return require("private-next-pages/veteran-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veteran-services"])
      });
    }
  